import React, { useEffect } from "react";
import { TextField } from "@mui/material";
import moment from "moment";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";

type DateInputPropsType = {
  register: UseFormRegister<any>;
  errors: any;
  setValue: UseFormSetValue<any>;
  variableName: string;
  label: string;
  maxDate?: string;
  minDate?: string;
  sx?: any;
  defaultValue?: string;
  disableUnderline?: boolean;
};

export default function DateInput(props: DateInputPropsType) {
  const {
    register,
    errors,
    setValue,
    variableName,
    label,
    maxDate = "",
    minDate = "",
    sx,
    defaultValue,
    disableUnderline = false,
  } = props;
  useEffect(() => {
    setValue(variableName, moment(defaultValue).format("YYYY-MM-DD"));
    if (defaultValue) {
    }
  }, [defaultValue, setValue, variableName]);

  return (
    <TextField
      id={variableName}
      margin="dense"
      sx={{ ...sx }}
      fullWidth
      label={label}
      placeholder="--"
      required
      type="date"
      inputProps={{
        min: moment(minDate).format("YYYY-MM-DD"),
        max: moment(maxDate).format("YYYY-MM-DD"),
      }}
      variant="standard"
      defaultValue={moment(new Date()).format("YYYY-MM-DD")}
      {...register(variableName)}
      onChange={(e) => {
        setValue(variableName, e.target.value);
      }}
      InputProps={{ disableUnderline: disableUnderline }}
      error={!!errors[variableName]}
      helperText={errors[variableName] ? errors[variableName].message : ""}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
}
